/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

import { RootState } from 'redux/schemas';
import { MentoringProgramActionItem } from 'redux/schemas/models/mentoring-program-action-items';
import { byActionItemId } from 'athena/components/mentoring-program/home/participant/utils';

export const getMentoringProgramActionItemsList = (connectionId: number) => createSelector(
  (state: RootState) => state.models.mentorshipProgramActionItems[connectionId]?.items,
  (state, ids: number[]) => ids,
  (
    items: Record<number, MentoringProgramActionItem>,
    ids: number[],
  ) => ids.map((id) => items?.[id]),
);

export const getMentoringProgramActionItems = (connectionId: number) => (state: RootState) => (
  Object.values(state.models.mentorshipProgramActionItems[connectionId]?.items || {}).sort(byActionItemId)
);

export const getMentoringProgramActionItemsTotalCount = (connectionId: number) => (state: RootState) => (
  state.models.mentorshipProgramActionItems[connectionId]?.totalCount
);
